const initialState = {
    city_name: "",
    lat: null,
    long: null,
};
  
export default function locationReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case 'SET_LOCATION':
        return {
            ...state,
            ...action.payload,
        };
        default:
        return state;
    }
}
  